import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { GLOBAL } from './global';

@Injectable({
    providedIn: 'root'
})
export class SecurazeService {
    public url: string;

    constructor(
        private _http: HttpClient
    ) {
        this.url = GLOBAL.url;
    }

    listByChassis(token, item): Observable<any> {
        let json = JSON.stringify(item);
        json = encodeURIComponent(json);
        let params = `json=${json}&authorization=${token}`;
        let headers = new HttpHeaders().set('Content-Type', 'application/x-www-form-urlencoded').set('X-Requested-With', 'XMLHttpRequest');
        return this._http.post(`${this.url}/securaze/listbychassis?page=1`, params, { headers })
            .pipe(map(res => res));
    }

        // ... continuing from the previous code

    matchPO(token, item): Observable<any> {
        const json = encodeURIComponent(JSON.stringify(item));
        const params = `json=${json}&authorization=${token}`;
        const headers = new HttpHeaders().set('Content-Type', 'application/x-www-form-urlencoded').set('X-Requested-With', 'XMLHttpRequest');
        return this._http.post(`${this.url}/securaze/matchpo?page=1`, params, { headers })
            .pipe(map(res => res));
    }

    getProductInfo(token, id): Observable<any> {
        const params = `authorization=${token}`;
        const headers = new HttpHeaders().set('Content-Type', 'application/x-www-form-urlencoded').set('X-Requested-With', 'XMLHttpRequest');
        return this._http.post(`${this.url}/securaze/getproductinfo/${id}?page=1`, params, { headers })
            .pipe(map(res => res));
    }


    getCategories(token): Observable<any> {
        const params = `authorization=${token}`;
        const headers = new HttpHeaders().set('Content-Type', 'application/x-www-form-urlencoded').set('X-Requested-With', 'XMLHttpRequest');
        return this._http.post(`${this.url}/securaze/getcategories?page=1`, params, { headers })
            .pipe(map(res => res));
    }

    getInventoryInfo(token, id, type): Observable<any> {
        
        const sanitizedId = String(id).replace(/^\/+/, '');
        const json = encodeURIComponent(JSON.stringify(type));
        const params = `json=${json}&authorization=${token}`;
        const headers = new HttpHeaders()
            .set('Content-Type', 'application/x-www-form-urlencoded')
            .set('X-Requested-With', 'XMLHttpRequest');
        return this._http.post(
            `${this.url}/securaze/getinventoryinfo/${sanitizedId}?page=1`,
            params,
            { headers }
        ).pipe(map(res => res));
    }

    getContainers(token): Observable<any> {
        const params = `authorization=${token}`;
        const headers = new HttpHeaders().set('Content-Type', 'application/x-www-form-urlencoded').set('X-Requested-With', 'XMLHttpRequest');
        return this._http.post(`${this.url}/securaze/getcontainers?page=1`, params, { headers })
            .pipe(map(res => res));
    }

     deleteContainer(token: string, id: string): Observable<any> {
        const params = `authorization=${token}`;
        const headers = new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded', 'X-Requested-With': 'XMLHttpRequest' });

        return this._http.post(`${this.url}/securaze/deletecontainer/${id}?page=1`, params, { headers })
                          .pipe(map(res => res as any));
    }

    inventoriesContainer(token: string, id: string): Observable<any> {
        const params = `authorization=${token}`;
        const headers = new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded', 'X-Requested-With': 'XMLHttpRequest' });

        return this._http.post(`${this.url}/securaze/inventoriescontainer/${id}?page=1`, params, { headers })
                          .pipe(map(res => res as any));
    }

    assignCategories(token: string, categories: any): Observable<any> {
        let json = JSON.stringify(categories);
        json = encodeURIComponent(json);
        const params = `json=${json}&authorization=${token}`;
        const headers = new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded', 'X-Requested-With': 'XMLHttpRequest' });

        return this._http.post(`${this.url}/securaze/assigncategories?page=1`, params, { headers })
                          .pipe(map(res => res as any));
    }

      getSecurazeCategory(token: string, id: string): Observable<any> {
        const params = `authorization=${token}`;
        const headers = new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded', 'X-Requested-With': 'XMLHttpRequest' });

        return this._http.post(`${this.url}/securaze/getsecurazecategory/${id}?page=1`, params, { headers })
                          .pipe(map(res => res as any));
    }

    newContainer(token, container): Observable<any> {
        const json = encodeURIComponent(JSON.stringify(container));
        const params = `json=${json}&authorization=${token}`;
        const headers = new HttpHeaders().set('Content-Type', 'application/x-www-form-urlencoded').set('X-Requested-With', 'XMLHttpRequest');
        return this._http.post(`${this.url}/securaze/newcontainer?page=1`, params, { headers })
            .pipe(map(res => res));
    }

     matchItem(token: string, item: any): Observable<any> {
        let json = JSON.stringify(item);
        json = encodeURIComponent(json);
        const params = `json=${json}&authorization=${token}`;
        const headers = new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded', 'X-Requested-With': 'XMLHttpRequest' });

        return this._http.post(`${this.url}/securaze/matchitem?page=1`, params, { headers })
                          .pipe(map(res => res as any));
    }

    saveCategories(token: string, categories: any): Observable<any> {
        let json = JSON.stringify(categories);
        json = encodeURIComponent(json);
        const params = `json=${json}&authorization=${token}`;
        const headers = new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded', 'X-Requested-With': 'XMLHttpRequest' });

        return this._http.post(`${this.url}/securaze/savecategories?page=1`, params, { headers })
                          .pipe(map(res => res as any));
    }

    saveCategoriesMaster(token: string, categories: any): Observable<any> {
        let json = JSON.stringify(categories);
        json = encodeURIComponent(json);
        const params = `json=${json}&authorization=${token}`;
        const headers = new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded', 'X-Requested-With': 'XMLHttpRequest' });

        return this._http.post(`${this.url}/securaze/savecategoriesmaster?page=1`, params, { headers })
                          .pipe(map(res => res as any));
    }

     getCategoriesTree(token): Observable<any> {
        const params = `authorization=${token}`;
        const headers = new HttpHeaders().set('Content-Type', 'application/x-www-form-urlencoded').set('X-Requested-With', 'XMLHttpRequest');
        return this._http.post(`${this.url}/securaze/getcategoriestree?page=1`, params, { headers })
            .pipe(map(res => res));
    }

    newCategory(token, category): Observable<any> {
        const json = encodeURIComponent(JSON.stringify(category));
        const params = `json=${json}&authorization=${token}`;
        const headers = new HttpHeaders().set('Content-Type', 'application/x-www-form-urlencoded').set('X-Requested-With', 'XMLHttpRequest');
        return this._http.post(`${this.url}/securaze/newcategory?page=1`, params, { headers })
            .pipe(map(res => res));
    }

    getSpecsTree(token, id): Observable<any> {
        const params = `authorization=${token}`;
        const headers = new HttpHeaders().set('Content-Type', 'application/x-www-form-urlencoded').set('X-Requested-With', 'XMLHttpRequest');
        return this._http.post(`${this.url}/securaze/getspecstree/${id}?page=1`, params, { headers })
            .pipe(map(res => res));
    }

    getCategoriesTreeBot(id, apitoken, hidden): Observable<any> {
        const headers = new HttpHeaders().set('Content-Type', 'application/x-www-form-urlencoded').set('X-Requested-With', 'XMLHttpRequest');
        return this._http.get(`https://www.itaderp.com/backend/reports/get-categories-tree.php?id=${id}&apitoken=${apitoken}&hidden=${hidden}`, { headers })
            .pipe(map(res => res));
    }

    getTreeByAI(id, apitoken, chassis): Observable<any> {
        const headers = new HttpHeaders().set('Content-Type', 'application/x-www-form-urlencoded').set('X-Requested-With', 'XMLHttpRequest');
        return this._http.get(`https://www.itaderp.com/backend/reports//ia-tree-workflow.php?id=${id}&apitoken=${apitoken}&chassis=${chassis}`, { headers })
            .pipe(map(res => res));
    }

    getCategoriesMasterTreeBot(id, apitoken, hidden): Observable<any> {
        const headers = new HttpHeaders().set('Content-Type', 'application/x-www-form-urlencoded').set('X-Requested-With', 'XMLHttpRequest');
        return this._http.get(`https://www.itaderp.com/backend/reports/get-categories-master-tree.php?id=${id}&apitoken=${apitoken}&hidden=${hidden}`, { headers })
            .pipe(map(res => res));
    }

    editCategory(token, category): Observable<any> {
        const json = encodeURIComponent(JSON.stringify(category));
        const params = `json=${json}&authorization=${token}`;
        const headers = new HttpHeaders().set('Content-Type', 'application/x-www-form-urlencoded').set('X-Requested-With', 'XMLHttpRequest');
        return this._http.post(`${this.url}/securaze/editcategory?page=1`, params, { headers })
            .pipe(map(res => res));
    }


 deleteCategory(token: string, id: string): Observable<any> {
        const params = `authorization=${token}`;
        const headers = new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded', 'X-Requested-With': 'XMLHttpRequest' });

        return this._http.post(`${this.url}/securaze/deletecategory/${id}?page=1`, params, { headers })
                          .pipe(map(res => res as any));
    }


    hideCategory(token, category): Observable<any> {
        const json = encodeURIComponent(JSON.stringify(category));
        const params = `json=${json}&authorization=${token}`;
        const headers = new HttpHeaders().set('Content-Type', 'application/x-www-form-urlencoded').set('X-Requested-With', 'XMLHttpRequest');
        return this._http.post(`${this.url}/securaze/hidecategory?page=1`, params, { headers })
            .pipe(map(res => res));
    }

  

     newItem(token: string, item: any): Observable<any> {
        let json = JSON.stringify(item);
        json = encodeURIComponent(json);
        const params = `json=${json}&authorization=${token}`;
        const headers = new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded', 'X-Requested-With': 'XMLHttpRequest' });

        return this._http.post(`${this.url}/securaze/newitem?page=1`, params, { headers })
                          .pipe(map(res => res as any));
    }

    saveDrop(token: string, tree: any): Observable<any> {
        let json = JSON.stringify(tree);
        json = encodeURIComponent(json);
        const params = `json=${json}&authorization=${token}`;
        const headers = new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded', 'X-Requested-With': 'XMLHttpRequest' });

        return this._http.post(`${this.url}/securaze/savedrop?page=1`, params, { headers })
                          .pipe(map(res => res as any));
    }

    disableCollapse(token: string, tree: any): Observable<any> {
        let json = JSON.stringify(tree);
        json = encodeURIComponent(json);
        const params = `json=${json}&authorization=${token}`;
        const headers = new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded', 'X-Requested-With': 'XMLHttpRequest' });

        return this._http.post(`${this.url}/securaze/disablecollapse?page=1`, params, { headers })
                          .pipe(map(res => res as any));
    }

    getNodeCollapse(token): Observable<any> {
        const params = `authorization=${token}`;
        const headers = new HttpHeaders().set('Content-Type', 'application/x-www-form-urlencoded').set('X-Requested-With', 'XMLHttpRequest');
        return this._http.post(`${this.url}/securaze/getnodecollapse?page=1`, params, { headers })
            .pipe(map(res => res));
    }

    gedatabitraser(token,id): Observable<any> {
        const params = `authorization=${token}`;
        const headers = new HttpHeaders().set('Content-Type', 'application/x-www-form-urlencoded').set('X-Requested-With', 'XMLHttpRequest');
        return this._http.post(`${this.url}/securaze/getbitraser/${id}`, params, { headers })
            .pipe(map(res => res));
    }

}
